export default "# Friendly Links\n- a Blog by polomex ([Night Coder](https://nightcoder.ml/))";